// extracted by mini-css-extract-plugin
export default {"container":"MBv5wGR8DJ2Z9psqBlrU"};